import React from "react";
const Teamitem = ({ team = {} }) => {
  const { name, avatar } = team;
  return (
    <div className="checkbox-container">
      <img src={avatar} className="team-avater" alt={name} />
      <p className="label">{name}</p>
    </div>
  );
};

export default Teamitem;
